<template>
  <div class="home">
    <img :src="img" alt />
  </div>
</template>

<script>
// @ is an alias to /src
import index from '@/assets/index.jpg'
export default {
  name: 'home',
  data () {
    return {
      img: index
    }
  }
}
</script>
